// import React, { useEffect, useState, useCallback } from 'react';
// import Navigation from '../components/Navigation';
// import { NavLink } from 'react-router-dom';
// import base_url from '../config/Config';
// import axios from 'axios';
// import Sidebar from '../components/Sidebar';
// import Spinner from 'react-bootstrap/Spinner';
// import Cookies from 'js-cookie';
// import { FaEyeSlash } from 'react-icons/fa';

// const Customer = () => {
//     const [customer, setCustomer] = useState([]);
//     const [isDownloading, setIsDownloading] = useState(false);
//     const [isDownloadingDate, setIsDownloadingDate] = useState(false);
//     const [searchOption, setSearchOption] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchInput, setSearchInput] = useState('');
//     const date = new Date().toISOString().slice(0, 10);
//     const token = Cookies.get('authToken');

//     const customersPerPage = 50;


//     const getToday = () => {
//   const today = new Date();
//   return today.toISOString().split("T")[0];
// };

//     const getCustomer = useCallback(async () => {
//         try {
//             const response = await axios.get(`${base_url}/api/customer/customers`, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`,
//                 },
//             });

//             const sortedCustomers = response.data
//                 .sort((a, b) => b.id - a.id)
//                 // .sort((a, b) => new Date(b.createDate) - new Date(a.createDate))
//                 .map(customer => ({
//                     ...customer,
//                     selectedStateCode: '',
//                     actionPerformed: false,
//                 }));

//             setCustomer(sortedCustomers);
//         } catch (error) {
//             console.error('Error fetching customer data:', error);
//         }
//     }, [token]);

//     useEffect(() => {
//         getCustomer();
//     }, [getCustomer]);


//     const handleExportCustomer = async () => {
//         setIsDownloading(true);
//         try {
//             const response = await axios.get(`${base_url}/api/export/customers-single-loan`, {
//                 responseType: 'blob',
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                 },
//             });

//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `Pending_customer_data_${date}.xlsx`);
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);

//             alert('✅ Exported Pending Customer Data successfully');
//         } catch (error) {
//             console.error('❌ Error generating export:', error.response?.data || error.message);
//             alert('❌ Export Pending Customer Data failed');
//         } finally {
//             setIsDownloading(false);
//         }
//     };

//     const DateExportCustomer = async (customDate) => {
//         setIsDownloadingDate(true);
//         try {
//             // If no date passed, take today's date
//             const selectedDate = customDate || getToday();

//             const response = await axios.get(
//                 `${base_url}/api/customerFilter/downloadExcel?date=${selectedDate}`,
//                 {
//                     responseType: 'blob',
//                     headers: {
//                         'Authorization': `Bearer ${token}`,
//                     },
//                 }
//             );

//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `Customer_data_${selectedDate}.xlsx`);
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);

//             alert(`✅ Exported Customer Data for ${selectedDate} successfully`);
//         } catch (error) {
//             console.error('❌ Error generating export:', error.response?.data || error.message);
//             alert('❌ Export Customer Data failed');
//         } finally {
//             setIsDownloadingDate(false);
//         }
//     };

//     const handleSearch = (event) => {
//         event.preventDefault();
//         if (searchOption && searchInput) {
//             let url = '';
//             switch (searchOption) {
//                 case 'borrower_name':
//                     url = `${base_url}/api/customerFilter/search?borrowerName=${searchInput}`;
//                     break;
//                 case 'borrower_id':
//                     url = `${base_url}/api/customerFilter/search?customerId=${searchInput}`;
//                     break;
//                 case 'phone':
//                     url = `${base_url}/api/customerFilter/search?phone=${searchInput}`;
//                     break;
//                 default:
//                     break;
//             }
//             axios.get(url).then(
//                 (response) => {
//                     const sortedResults = response.data.sort((a, b) => new Date(b.createDate) - new Date(a.createDate));
//                     setCustomer(sortedResults);
//                 },
//                 (error) => {
//                     console.log(error);
//                 }
//             );
//         }
//     };

//     const indexOfLastCustomer = currentPage * customersPerPage;
//     const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
//     const customers = customer.slice(indexOfFirstCustomer, indexOfLastCustomer);
//     const totalPages = Math.ceil(customer.length / customersPerPage);
//     const maxPageButtons = 10;

//     const getPaginationRange = () => {
//         const mid = Math.floor(maxPageButtons / 2);
//         let start = Math.max(1, currentPage - mid);
//         let end = Math.min(totalPages, start + maxPageButtons - 1);
//         if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
//         return { start, end };
//     };

//     const { start: startPage, end: endPage } = getPaginationRange();

//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>Customer Details</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms mt-5 text-center'>
//                             <div className='row'>
//                                 <div className='col-md-12'>
//                                     <div className='searchtoll'>
//                                         <form onSubmit={handleSearch}>
//                                             <div className='row'>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className="form-group required">
//                                                         <select className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
//                                                             <option value="">Search By</option>
//                                                             <option value="borrower_name">Borrower Name</option>
//                                                             <option value="borrower_id">Customer Id</option>
//                                                             <option value="phone">Phone</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-3 col-6">
//                                                     <div className="form-group required">
//                                                         <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-1 col-3">
//                                                     <div className="form-group required iconsss">
//                                                         <button type="submit" className="btn btn-sm btn-primary">Search</button>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className="export mt-1">
//                                                         <NavLink to="#" className="exportbutton" onClick={handleExportCustomer}>
//                                                             {isDownloading ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>Download</>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2">
//                                                     <input
//                                                         type="date"
//                                                         className="form-control"
//                                                         onChange={(e) => DateExportCustomer(e.target.value)} // Custom date
//                                                     />
//                                                 </div>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className="export mt-1">
//                                                         <NavLink
//                                                             to="#"
//                                                             className="exportbutton"
//                                                             onClick={() => DateExportCustomer()} // Default = today's date
//                                                         >
//                                                             {isDownloadingDate ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>Today Customer</>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                 </div>

//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 col-lg-12'>
//                                     <div className='kyc table-responsive table-striped mt-3 mb-2'>
//                                         {customer.length > 0 ? (
//                                             <table className="styled-table">
//                                                 <thead>
//                                                     <tr style={{ textAlign: "left" }}>
//                                                         <th>Customer_Id</th>
//                                                         <th>Borrower_Name</th>
//                                                         <th>Pan_Number</th>
//                                                         <th>Phone_Number</th>
//                                                         <th>Agenet_Name</th>
//                                                         <th>Agenet_Code</th>
//                                                         <th>Create_Date</th>
//                                                         <th>Status</th>
//                                                         <th>Action</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {customers.map((data, index) => (
//                                                         <tr key={index}>
//                                                             <td>{data.id}</td>
//                                                             <td>{data.borrowerName}</td>
//                                                             <td>{data.panNumber}</td>
//                                                             <td>{data.mobileNumber}</td>
//                                                             <td>{data.employeeName}</td>
//                                                             <td>{data.employeeId}</td>
//                                                             <td>{data.createDate}</td>
//                                                             <td style={{
//                                                                 color:
//                                                                     data.status === 1 ? 'green' :
//                                                                         data.status === 2 ? 'red' :
//                                                                             data.status === 3 ? 'orange' :
//                                                                                 'black',
//                                                                 fontWeight: 'bold'

//                                                             }}>
//                                                                 {data.status === 0 ? "Pending" :
//                                                                     data.status === 1 ? "Approved" :
//                                                                         data.status === 2 ? "Rejected" :
//                                                                             data.status === 3 ? "Under Review" :
//                                                                                 "Unknown"}
//                                                             </td>

//                                                             <td className='iconss'>
//                                                                 <NavLink to={`/operation/ViewVerifiedCustomer?id=${encodeURIComponent(data.id)}`}>
//                                                                     <FaEyeSlash />
//                                                                 </NavLink>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         ) : (
//                                             "No customers uploaded today."
//                                         )}
//                                     </div>

//                                     <div className="pagination-container">
//                                         <div className="pagination-box">
//                                             {startPage > 1 && (
//                                                 <>
//                                                     <button onClick={() => setCurrentPage(1)}>1</button>
//                                                     <span className="dots">...</span>
//                                                 </>
//                                             )}
//                                             {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
//                                                 <button
//                                                     key={startPage + i}
//                                                     className={currentPage === startPage + i ? 'active' : ''}
//                                                     onClick={() => setCurrentPage(startPage + i)}
//                                                 >
//                                                     {startPage + i}
//                                                 </button>
//                                             ))}
//                                             {endPage < totalPages && (
//                                                 <>
//                                                     <span className="dots">...</span>
//                                                     <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>

//                                 </div>
//                                 <hr />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Customer;



import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import Cookies from 'js-cookie';
import { FaEyeSlash } from 'react-icons/fa';
import PageLoader from '../components/PageLoader';

const Customer = () => {
    const [customer, setCustomer] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingDate, setIsDownloadingDate] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchInput, setSearchInput] = useState('');
    const [permissions, setPermissions] = useState([]);
    const date = new Date().toISOString().slice(0, 10);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isDownloadingDateTwo, setIsDownloadingDateTwo] = useState(false);
    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [pageLoading, setPageLoading] = useState(true);

    const token = Cookies.get('authToken');

    const customersPerPage = 50;

    // Fetch permissions for logged-in admin
    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]))
            .finally(() => setPageLoading(false));
    }, []);

    // Permission check helper
    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete; // using canDelete for download
            default: return false;
        }
    }, [permissions]);

    const getToday = () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    };



    // Fetch customers
    const getCustomer = useCallback(async () => {
        if (!hasPermission('Customer', 'view')) return;

        const CACHE_KEY = 'customerList_cache';

        // Pre-fill with cached data (loader stays on until API responds)
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
            setCustomer(JSON.parse(cached));
        }

        try {
            const response = await axios.get(`${base_url}/api/customer/customers`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            const sortedCustomers = response.data
                .sort((a, b) => (b.customer?.id ?? 0) - (a.customer?.id ?? 0))
                .map(item => ({
                    ...item,
                    selectedStateCode: '',
                    actionPerformed: false,
                }));

            setCustomer(sortedCustomers);
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(sortedCustomers));
        } catch (error) {
            console.error('Error fetching customer data:', error);
        } finally {
            setPageLoading(false);
        }
    }, [token, hasPermission]);

    useEffect(() => {
        getCustomer();
    }, [getCustomer]);


    // ✅ Fetch all branches
    const fetchBranches = useCallback(async () => {
        try {
            const response = await axios.get(`${base_url}/api/admin/branches`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setBranches(response.data || []);
        } catch (error) {
            console.error('Error fetching branches:', error);
        }
    }, [token]);

    //   // ✅ Fetch data for selected branch
    //   const fetchBranchData = useCallback(async () => {
    //     if (!selectedBranch) return;
    //     try {
    //       const response = await axios.get(
    //         `${base_url}/api/branchReport/branch?branch=${selectedBranch}`,
    //         { headers: { Authorization: `Bearer ${token}` } }
    //       );
    //       setCustomer(response.data || []);
    //     } catch (error) {
    //       console.error('Error fetching branch data:', error);
    //     }
    //   }, [selectedBranch, token]);

    const fetchBranchData = useCallback(async () => {
        if (!selectedBranch) return;

        try {
            const response = await axios.get(
                `${base_url}/api/branchReport/branch?branch=${selectedBranch}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const normalizedData = (response.data || []).map((item) => ({
                id: item.customerId,          // backend se jo hai wahi
                borrowerName: item.borrowerName,
                panNumber: item.panNumber,
                mobileNumber: item.mobileNumber,
                employeeName: item.employeeName,
                employeeId: item.employeeId,  // ✅ backend value directly
                createDate: item.createdDate,
                status: item.status ?? 0,
            }));

            setCustomer(normalizedData);

        } catch (error) {
            console.error("Error fetching branch data:", error);
        }
    }, [selectedBranch, token]);



    // ✅ Initial Load
    useEffect(() => {
        fetchBranches();
    }, [fetchBranches]);

    useEffect(() => {
        fetchBranchData();
    }, [fetchBranchData]);


    // Export full customer data
    const handleExportCustomer = async () => {
        if (!hasPermission('Customer', 'download')) return alert('You do not have permission to download!');
        setIsDownloading(true);
        try {
            // const response = await axios.get(`${base_url}/api/export/customers-single-loan`, {
            const response = await axios.get(`${base_url}/api/customerFilter/allDownload`, {
                responseType: 'blob',
                headers: { 'Authorization': `Bearer ${token}` },
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `All_customer_data_${date}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('✅ Exported All Customer Data successfully');
        } catch (error) {
            console.error('❌ Error generating export:', error.response?.data || error.message);
            alert('❌ Export All Customer Data failed');
        } finally {
            setIsDownloading(false);
        }
    };

    // Export customer data by date
    const DateExportCustomer = async (customDate) => {
        if (!hasPermission('Customer', 'download')) return alert('You do not have permission to download!');
        setIsDownloadingDateTwo(true);
        try {
            const selectedDate = customDate || getToday();
            const response = await axios.get(
                `${base_url}/api/customerFilter/downloadExcel?date=${selectedDate}`,
                { responseType: 'blob', headers: { 'Authorization': `Bearer ${token}` } }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Customer_data_${selectedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert(`✅ Exported Customer Data for ${selectedDate} successfully`);
        } catch (error) {
            console.error('❌ Error generating export:', error.response?.data || error.message);
            alert('❌ Export Customer Data failed');
        } finally {
            setIsDownloadingDateTwo(false);
        }
    };

    // two date FIlter

    const DateExportCustomerDate = async (startDate, endDate) => {
        if (!hasPermission('Customer', 'download')) {
            return alert('You do not have permission to download!');
        }

        if (!startDate || !endDate) {
            return alert('Please select both Start Date and End Date!');
        }

        setIsDownloadingDateTwo(true);

        try {
            const response = await axios.get(
                `${base_url}/api/customerFilter/downloadBetweenDates?startDate=${startDate}&endDate=${endDate}`,
                { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Customer_data_${startDate}_to_${endDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert(`✅ Exported Customer Data from ${startDate} to ${endDate} successfully`);
        } catch (error) {
            console.error('❌ Error generating export:', error.response?.data || error.message);
            alert('❌ Export Customer Data failed');
        } finally {
            setIsDownloadingDateTwo(false);
        }
    };


    // Search handler
    const handleSearch = (event) => {
        if (!hasPermission('Customer', 'view')) return alert('You do not have permission to view!');
        event.preventDefault();

        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'borrower_name':
                    url = `${base_url}/api/customerFilter/search?borrowerName=${searchInput}`;
                    break;
                case 'borrower_id':
                    url = `${base_url}/api/customerFilter/search?customerId=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api/customerFilter/search?phone=${searchInput}`;
                    break;
                case 'panNumber':
                    url = `${base_url}/api/customerFilter/search?panNumber=${searchInput}`;
                    break;
                case 'loanId':
                    url = `${base_url}/api/customerFilter/search?loanId=${searchInput}`;
                    break;
                default: break;
            }

            axios.get(url, { headers: { Authorization: `Bearer ${token}` } }).then(
                response => {
                    const normalized = response.data
                        .sort((a, b) => new Date(b.createDate) - new Date(a.createDate))
                        .map(item => ({
                            customer: {
                                id: item.id ?? item.customerId,
                                borrowerName: item.borrowerName,
                                panNumber: item.panNumber,
                                mobileNumber: item.mobileNumber,
                                employeeName: item.employeeName,
                                employeeId: item.employeeId,
                                createDate: item.createDate,
                                status: item.status,
                            },
                            loanId: item.loanId,
                            loanStatus: item.loanStatus,
                        }));
                    setCustomer(normalized);
                    setCurrentPage(1);
                },
                error => console.log(error)
            );
        }
    };



    //  // ✅ Search Filter Logic (same as your repayment page)
    // const handleSearch = (event) => {
    //     event.preventDefault();
    //     let filtered = [...customer];

    //     if (searchOption && searchInput) {
    //         switch (searchOption) {
    //             case 'borrower_name':
    //                 filtered = filtered.filter(item =>
    //                     item.borrowerName?.toLowerCase().includes(searchInput.toLowerCase())
    //                 );
    //                 break;
    //             case 'borrower_id':
    //                 filtered = filtered.filter(item =>
    //                     item.id?.toString() === searchInput
    //                 );
    //                 break;
    //             case 'phone':
    //                 filtered = filtered.filter(item =>
    //                     item.phone?.toString() === searchInput
    //                 );
    //                 break;
    //             case 'panNumber':
    //                 filtered = filtered.filter(item =>
    //                     item.panNumber?.toString() === searchInput
    //                 );
    //                 break;
    //             case 'loanId':
    //                 filtered = filtered.filter(item =>
    //                     item.loanId?.toString().includes(searchInput)
    //                 );
    //                 break;
    //             default:
    //                 break;
    //         }
    //     }

    //     setCustomer(filtered);
    //     setCurrentPage(1);
    // };


    // Deduplicate: one row per customer, keep latest loan, sort by customer ID desc
    const uniqueCustomers = useMemo(() =>
        Object.values(
            customer.reduce((acc, item) => {
                const cid = item.customer?.id;
                if (!cid) return acc;
                const existing = acc[cid];
                if (!existing || (item.loanId ?? -1) > (existing.loanId ?? -1)) {
                    acc[cid] = item;
                }
                return acc;
            }, {})
        ).sort((a, b) => (b.customer?.id ?? 0) - (a.customer?.id ?? 0))
    , [customer]);

    // Pagination logic
    const indexOfLastCustomer = currentPage * customersPerPage;
    const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
    const customers = uniqueCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);
    const totalPages = Math.ceil(uniqueCustomers.length / customersPerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();

    if (pageLoading) return <PageLoader text="Loading customers..." />;

    if (!hasPermission('Customer', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }


    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'><Sidebar /></div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            {/* Row 1 — Search */}
                                            <div className='row g-2 align-items-center mb-2'>
                                                <div className="col-md-2 col-12">
                                                    <select className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
                                                        <option value="">Search By</option>
                                                        <option value="borrower_name">Borrower Name</option>
                                                        <option value="borrower_id">Customer Id</option>
                                                        <option value="phone">Phone</option>
                                                        <option value="panNumber">Pan Number</option>
                                                        <option value="loanId">Loan Id</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-4 col-12">
                                                    <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
                                                </div>
                                                <div className="col-md-2 col-6">
                                                    <button type="submit" className="btn btn-primary w-100">Search</button>
                                                </div>
                                                <div className="col-md-2 col-12">
                                                    <select
                                                        className="form-control"
                                                        value={selectedBranch}
                                                        onChange={(e) => setSelectedBranch(e.target.value)}
                                                    >
                                                        <option value="">Select Branch</option>
                                                        {branches.map((branch, index) => (
                                                            <option key={index} value={branch}>
                                                                {branch}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2 col-6">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success w-100"
                                                        onClick={handleExportCustomer}
                                                        disabled={!hasPermission('Customer', 'download')}
                                                    >
                                                        {isDownloading ? <Spinner animation="border" size="sm" /> : 'All Download'}
                                                    </button>
                                                </div>
                                            </div>
                                            {/* Row 2 — Export by date */}
                                            <div className='row g-2 align-items-center'>
                                                <div className="col-md-3 col-12">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                        disabled={!hasPermission('Customer', 'download')}
                                                    />
                                                </div>
                                                <div className="col-md-3 col-12">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                        disabled={!hasPermission('Customer', 'download')}
                                                    />
                                                </div>
                                                <div className="col-md-3 col-6">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success w-100"
                                                        onClick={() => DateExportCustomerDate(startDate, endDate)}
                                                        disabled={!hasPermission('Customer', 'download') || !startDate || !endDate}
                                                    >
                                                        {isDownloadingDateTwo ? <Spinner animation="border" size="sm" /> : 'Export'}
                                                    </button>
                                                </div>
                                                <div className="col-md-3 col-6">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info w-100"
                                                        onClick={() => DateExportCustomer()}
                                                        disabled={!hasPermission('Customer', 'download')}
                                                    >
                                                        {isDownloadingDate ? <Spinner animation="border" size="sm" /> : 'Today'}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className='col-md-12 col-lg-12'>
                                    <div className='kyc table-responsive mt-3 mb-2'>
                                        {pageLoading ? (
                                            <PageLoader text="Loading customers..." />
                                        ) : customer.length > 0 ? (
                                            <table className="styled-table">
                                                <thead>
                                                    <tr>
                                                        <th>Customer_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Pan_Number</th>
                                                        <th>Phone_Number</th>
                                                        <th>Agenet_Name</th>
                                                        <th>Agenet_Code</th>
                                                        <th>Create_Date</th>
                                                        <th>Status</th>
                                                        <th>Loan_Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {customers.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.customer?.id}</td>
                                                            <td>{data.customer?.borrowerName}</td>
                                                            <td>{data.customer?.panNumber}</td>
                                                            <td>{data.customer?.mobileNumber}</td>
                                                            <td>{data.customer?.employeeName}</td>
                                                            <td>{data.customer?.employeeId}</td>
                                                            <td>{data.customer?.createDate}</td>
                                                            <td>
                                                                <span style={{
                                                                    display: 'inline-block',
                                                                    padding: '3px 10px',
                                                                    borderRadius: '20px',
                                                                    fontSize: '11px',
                                                                    fontWeight: '700',
                                                                    letterSpacing: '0.3px',
                                                                    background:
                                                                        data.customer?.status === 0 ? '#f1f5f9' :
                                                                        data.customer?.status === 1 ? '#dcfce7' :
                                                                        data.customer?.status === 2 ? '#fee2e2' :
                                                                        data.customer?.status === 3 ? '#fef9c3' : '#f1f5f9',
                                                                    color:
                                                                        data.customer?.status === 0 ? '#475569' :
                                                                        data.customer?.status === 1 ? '#15803d' :
                                                                        data.customer?.status === 2 ? '#b91c1c' :
                                                                        data.customer?.status === 3 ? '#92400e' : '#475569',
                                                                }}>
                                                                    {data.customer?.status === 0 ? 'Pending' :
                                                                     data.customer?.status === 1 ? 'Approved' :
                                                                     data.customer?.status === 2 ? 'Rejected' :
                                                                     data.customer?.status === 3 ? 'Under Review' : 'Unknown'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {data.loanStatus != null ? (
                                                                    <span style={{
                                                                        display: 'inline-block',
                                                                        padding: '3px 10px',
                                                                        borderRadius: '20px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '700',
                                                                        background: '#dbeafe',
                                                                        color: '#1d4ed8',
                                                                    }}>
                                                                        {data.loanStatus}
                                                                    </span>
                                                                ) : (
                                                                    <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {hasPermission('Customer', 'view') ? (
                                                                    <NavLink to={`/operation/ViewVerifiedCustomer?id=${encodeURIComponent(data.customer?.id)}`}>
                                                                        <FaEyeSlash />
                                                                    </NavLink>
                                                                ) : (
                                                                    <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p className="empty-state">No customers found.</p>
                                        )}
                                    </div>

                                    <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Customer;
